module.exports = __webpack_public_path__ + "img/weigth-stations2.2f322f0e.png";